// extracted by mini-css-extract-plugin
module.exports = {"spinner":"dashboard-chart_spinner__LSXFs","shadowChartContainer":"dashboard-chart_shadowChartContainer__eA_6I"};